const HIDDEN_MASTER_CLIENT_STATUSES = new Set(['INACTIVE', 'DELETED']);

export interface MasterClientActivity {
  status?: string | null;
  Status?: string | null;
}

/**
 * True when a master client (group) should appear in the group pick list.
 * INACTIVE and DELETED are hidden; LAPSED and any other status remain visible.
 * Missing status is treated as selectable so older payloads stay visible.
 */
export function isActiveMasterClient(client: MasterClientActivity | null | undefined): boolean {
  if (!client) {
    return false;
  }

  const status = (client.status ?? client.Status ?? '').trim().toUpperCase();
  if (!status) {
    return true;
  }

  return !HIDDEN_MASTER_CLIENT_STATUSES.has(status);
}
